import { Link, useLocation } from 'react-router-dom'
import { SITE } from '@shared/config'
import { useSeo } from '@shared/lib/seo'
import { Header } from '@widgets/header'
import { Footer } from '@widgets/footer'
import * as styles from './NotFoundPage.css'

export function NotFoundPage() {
  const location = useLocation()

  useSeo({
    title: `Page Not Found | ${SITE.name}`,
    description: `The requested ${SITE.name} page could not be found. Browse practical caudex and succulent-care guides.`,
    path: location.pathname,
    robots: 'noindex, follow',
    canonical: false,
  })

  return (
    <div className={styles.page}>
      <Header />
      <main className={styles.main}>
        <div className={styles.content}>
          <p className={styles.code}>Error 404</p>
          <h1 className={styles.title}>This path has gone wild.</h1>
          <p className={styles.description}>
            The page may have moved or the address may be incomplete. Return home or continue with one of our practical growing guides.
          </p>
          <nav className={styles.links} aria-label="Recovery links">
            <Link className={styles.primaryLink} to="/">Browse latest guides</Link>
            <Link className={styles.secondaryLink} to="/category/succulent/">Explore succulents</Link>
          </nav>
        </div>
      </main>
      <Footer />
    </div>
  )
}
